import React from "react";
import { motion } from "framer-motion";
import { easyonComplianceTimeline } from "../../data/easyonPageContent";
import { EasyonReveal } from "./EasyonMotion";

export const EasyonComplianceTimelineSection = () => (
    <section className="eo-compliance">
        <div className="eo-container">
            <EasyonReveal className="eo-compliance__head">
                <span className="eo-eyebrow">Compliance Timeline</span>
                <h2 className="eo-h2">GST Workflow with Timeline Automation</h2>
            </EasyonReveal>
            <div className="eo-compliance__timeline">
                {easyonComplianceTimeline.map((item, i) => (
                    <motion.div
                        key={item.title}
                        className="eo-compliance__step"
                        initial={{ opacity: 0, y: 14 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false }}
                        transition={{ delay: i * 0.08 }}
                    >
                        <span>{i + 1}</span>
                        <div>
                            <strong>{item.title}</strong>
                            <p>{item.note}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);
